<template>
  <div class="sibiu">
    <h1>Hermannstadt, Sibiu</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/sibi_1kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: deutsch-evangelische Kirche" 
        @click="callImageClick('Hermannstadt, Sibiu: deutsch-evangelische Kirche', 'sibi_1.jpg', $event)">
        <br>Hermannstadt, Sibiu: deutsch-evangelische Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/sibi_2kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: deutsch-evangelische Kirche" 
        @click="callImageClick('Hermannstadt, Sibiu: deutsch-evangelische Kirche', 'sibi_2.jpg', $event)">
        <br>Hermannstadt, Sibiu: deutsch-evangelische Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/sibi_3kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Ursulinenkirche"
        @click="callImageClick('Hermannstadt, Sibiu: Ursulinenkirche', 'sibi_3.jpg', $event)">
        <br>Hermannstadt, Sibiu: Ursulinenkirche
      </div>
      <div class="foto">
				<img src="../assets/fotos/sibi_4kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu: Unterstadt"
        @click="callImageClick('Hermannstadt, Sibiu: Unterstadt', 'sibi_4.jpg', $event)">
        <br>Hermannstadt, Sibiu: Unterstadt
      </div>
      
      <div class="foto">
				<img src="../assets/fotos/Sibiu_1_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_1.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_2_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_2.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_3_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_3.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_4_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_4.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_5_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_5.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_6_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_6.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_7_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_7.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_8_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_8.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_9_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_9.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_a_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_a.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_b_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_b.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_c_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_c.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_d_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_d.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_e_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_e.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_f_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_f.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
      <div class="foto">
				<img src="../assets/fotos/Sibiu_g_kl.jpg" width="125" height="110" border="0" alt="Hermannstadt, Sibiu"
        @click="callImageClick('Hermannstadt, Sibiu', 'Sibiu_g.jpg', $event)">
        <br>Hermannstadt, Sibiu
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>